import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const COLLECTION = "liveMatches";

function liveRef(liveMatchId) {
  return doc(db, COLLECTION, liveMatchId);
}

export async function fetchLiveMatch(liveMatchId) {
  const snap = await getDoc(liveRef(liveMatchId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function createLiveMatch(liveMatchId, data) {
  await setDoc(liveRef(liveMatchId), data);
}

export async function updateLiveMatch(liveMatchId, data) {
  await updateDoc(liveRef(liveMatchId), data);
}

export async function setLiveMatch(liveMatchId, data) {
  await setDoc(liveRef(liveMatchId), data, { merge: true });
}

export async function deleteLiveMatch(liveMatchId) {
  await deleteDoc(liveRef(liveMatchId));
}

/** @returns {import('firebase/firestore').Unsubscribe} */
export function subscribeLiveMatchDoc(liveMatchId, onData) {
  return onSnapshot(
    liveRef(liveMatchId),
    (snap) => {
      const meta = {
        fromCache: snap.metadata.fromCache,
        hasPendingWrites: snap.metadata.hasPendingWrites,
      };
      if (snap.exists()) onData({ id: snap.id, ...snap.data() }, meta);
      else onData(null, meta);
    },
    { includeMetadataChanges: true }
  );
}

export function newLiveMatchTimestamps() {
  const now = serverTimestamp();
  return { createdAt: now, updatedAt: now };
}

export { COLLECTION as LIVE_MATCHES_COLLECTION };
